import React from 'react';
import { MDBDataTable } from 'mdbreact';
import dayjs from 'dayjs';
import { Button } from 'reactstrap';

const columns = [
  {
    label: 'Image',
    field: 'profilePicture',
    sort: 'disabled',
    width: 150,
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Phone #',
    field: 'phone',
    sort: 'asc',
    width: 200,
  },
  {
    label: 'Areas of Expertise',
    field: 'areas',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Districts',
    field: 'districts',
    sort: 'asc',
    width: 150,
  },
  {
    label: 'Language',
    field: 'languages',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Date of Joining',
    field: 'createdAt',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Actions',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const AdvisorsList = (props) => {
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        data={{
          columns: columns,
          rows:
            props.advisors &&
            props.advisors.map((x) => ({
              name: x.name,
              profilePicture: (
                <img
                  src={x.image}
                  className='rounded-circle avatar-sm card-img'
                />
              ),
              phone: x.phone,
              createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
              actions: (
                <Button color='info' onClick={() => props.editAdvisor(x)}>
                  Edit
                </Button>
              ),
              areas: x.expertises?.map((z) => z.name).join(', '),
              districts: x.districts?.map((z) => z.name).join(', '),
              languages: x.languages?.map((z) => z.name).join(', '),
              vegetables: x.vegetables?.map((z) => z.name).join(', '),
            })),
        }}
      />
    </>
  );
};

export default AdvisorsList;
